import { render, staticRenderFns } from "./StepCourses.vue?vue&type=template&id=7cb0effe&scoped=true&"
import script from "./StepCourses.vue?vue&type=script&lang=js&"
export * from "./StepCourses.vue?vue&type=script&lang=js&"
import style0 from "./StepCourses.vue?vue&type=style&index=0&id=7cb0effe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb0effe",
  null
  
)

export default component.exports